import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'components/modal';
import format from 'format-number';
import Loader from '../../../components/loader/spinner';
import Paging from '../../../components/paging';
import EmptyState from 'components/empty-state';

const SaldoVendorModal = ({ open, handleClose, request }) => {
  const [state, setState] = useState({
    dataVendor: [],
    isLoading: true,
    paging: 16,
    pageCount: 0,
    currentPage: 1,
    keyword: '',
  });

  const { dataVendor, isLoading, paging, pageCount, currentPage, keyword } = state;

  const changeState = (newSetState) => {
    setState((prevState) => ({
      ...prevState,
      ...newSetState,
    }));
  };

  useEffect(() => {
    if (!keyword) {
      loadData();
    }
  }, [currentPage, paging, keyword]);

  const loadData = () => {
    const formData = {
      page: currentPage,
      paging: paging,
      keyword: keyword,
    };

    changeState({ isLoading: true });

    request('ppob-vendor', formData, 'POST')
      .then((response) => {
        if (response.success) {
          const result = response.data;
          changeState({
            dataVendor: result.data,
            pageCount: result.last_page,
          });
        }
      })
      .finally(() => {
        changeState({ isLoading: false });
      });
  };

  const handlePageClick = (data) => {
    changeState({
      isLoading: true,
      currentPage: data,
    });
  };

  const handleChange = (event) => {
    const { value, name } = event.target;
    changeState({
      [name]: value,
      currentPage: 1,
    });
  };

  const handleModalClose = () => {
    handleClose();
    changeState({
      currentPage: 1,
      keyword: '',
    });
  };

  return (
    <Modal show={open} onClose={handleModalClose} size='3xl' dismissible>
      <ModalHeader className='sticky top-0 z-10 border-b border-gray-200 bg-white'>
        <div className='flex w-full flex-col gap-3 pr-2 sm:flex-row sm:items-center sm:justify-between'>
          <span className='text-lg font-bold text-gray-900'>Saldo Vendor PPOB</span>
          <input
            name='keyword'
            type='text'
            placeholder='Search ...'
            className='form-input h-10 w-full text-xs sm:max-w-xs'
            value={keyword}
            onChange={handleChange}
            onKeyUp={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                loadData();
              }
            }}
          />
        </div>
      </ModalHeader>
      <ModalBody className='flex-1 bg-white'>
        <div className='flex flex-col'>
          {isLoading ? (
            <div className='flex justify-center items-center h-32'>
              <Loader active type='ball-beat' />
            </div>
          ) : dataVendor.length === 0 ? (
            <EmptyState
              variant='default'
              title='Belum ada vendor'
              subtitle='Data vendor akan muncul di sini.'
            />
          ) : (
            <div className='grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4'>
              {dataVendor.map((item, index) => {
                return (
                  <div
                    key={index}
                    className='flex min-w-0 flex-col items-center justify-between rounded-lg border-2 bg-primary px-3 py-3 text-center hover:shadow-lg'
                  >
                    <div className='w-full truncate font-bold text-white'>
                      {item.ppob_vendor_code}
                    </div>
                    <div className='mt-1 w-full break-words text-sm font-bold text-white'>
                      <strong>
                        Rp{' '}
                        {format({
                          prefix: '',
                          integerSeparator: '.',
                        })(item.ppob_vendor_saldo)}
                      </strong>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter className='sticky bottom-0 z-10 border-t border-gray-200 bg-white'>
        {pageCount > 1 && (
          <div className='flex items-center justify-center mr-auto'>
            <Paging
              handlePageClick={handlePageClick}
              pageCount={pageCount}
              currentPage={currentPage}
            />
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default SaldoVendorModal;
